import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Label from '../../../../../components/Label';

export default function ErrorLabel({ error }) {
  return (
    <Label role="tooltip" basic color="red" pointing><FormattedMessage {...error} /></Label>
  );
}

ErrorLabel.propTypes = {
  error: PropTypes.object,
};
